import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const CSRF_STORAGE_KEY = "zlg_csrf_token";
export const clearCsrfToken = () => sessionStorage.removeItem(CSRF_STORAGE_KEY);

const captureCsrfToken = (data) => {
  if (data && typeof data === "object" && data.csrf_token) {
    sessionStorage.setItem(CSRF_STORAGE_KEY, data.csrf_token);
  }
};

api.interceptors.request.use((config) => {
  if (["post", "put", "patch", "delete"].includes(config.method)) {
    const token = sessionStorage.getItem(CSRF_STORAGE_KEY);
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    captureCsrfToken(response.data);
    // Global state sync: every successful mutation may change badge counts and
    // commercial state elsewhere — signal listeners (nav badges, banners) to refetch.
    if (["post", "put", "patch", "delete"].includes(response.config?.method)) {
      window.dispatchEvent(new Event("notifications:changed"));
    }
    return response;
  },
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retried &&
      !original.url.includes("/auth/login") &&
      !original.url.includes("/auth/refresh")
    ) {
      original._retried = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        // refresh failed; caller handles 401
      }
    }
    if (
      error.response?.status === 403 &&
      !original._csrfRetried &&
      !original.url.includes("/auth/") &&
      typeof error.response?.data?.detail === "string" &&
      error.response.data.detail.includes("CSRF")
    ) {
      original._csrfRetried = true;
      try {
        await api.get("/auth/me"); // re-syncs the stored session token
        return api(original);
      } catch {
        // session gone; caller handles 403
      }
    }
    return Promise.reject(error);
  }
);
